<template>
  <select
    :id="inputId"
    ref="select"
    class="form-select"
    :disabled="disabled"
    :value="modelValue || ''"
  >
    <option value="">{{ placeholder }}</option>
    <option v-for="admin in availableOptions" :key="admin.id" :value="String(admin.id)">
      {{ admin.name }}{{ admin.mobileNumber ? ' — ' + admin.mobileNumber : '' }}
    </option>
  </select>
</template>

<script>
import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.min.css';

export default {
  name: 'AdminSelect',
  props: {
    modelValue: { type: [String, Number], default: '' },
    options: { type: Array, default: () => [] },
    historical: { type: Object, default: null },
    inputId: { type: String, required: true },
    placeholder: { type: String, default: 'اختر الموظف' },
    disabled: Boolean,
  },
  emits: ['update:modelValue'],
  computed: {
    availableOptions() {
      const options = [...this.options];
      if (this.modelValue && this.historical &&
          !options.some(admin => String(admin.id) === String(this.modelValue))) {
        options.push({
          id: this.modelValue,
          name: this.historical.name + ' (غير نشط أو تاريخي)',
          mobileNumber: this.historical.mobileNumber || '',
        });
      }
      return options;
    },
  },
  watch: {
    modelValue() { this.syncSelection(); },
    options: {
      handler() { this.syncSelection(); },
      deep: true,
    },
    disabled() { this.syncSelection(); },
  },
  mounted() {
    const select = $(this.$refs.select);
    select.select2({
      width: '100%',
      dir: 'rtl',
      placeholder: this.placeholder,
      allowClear: true,
    });
    select.on('change.adminSelect', () => {
      this.$emit('update:modelValue', select.val() || '');
    });
    this.syncSelection();
  },
  beforeUnmount() {
    const select = $(this.$refs.select);
    select.off('.adminSelect');
    if (select.hasClass('select2-hidden-accessible')) select.select2('destroy');
  },
  methods: {
    syncSelection() {
      this.$nextTick(() => {
        if (!this.$refs.select) return;
        const select = $(this.$refs.select);
        select.prop('disabled', this.disabled);
        select.val(this.modelValue ? String(this.modelValue) : '').trigger('change.select2');
      });
    },
  },
};
</script>
